import React from "react";

import Add from "./Add";
import Edit from "./Edit";
import Overview from "./Overview";
export const Currency = () => {
  return (
    <Overview />
  );
};

export const AddCurrency = () => {
  return (
    <Add />
  );
};

export const EditCurrency = () => {
  return (
    <Edit />
  );
};
